<template>
    <div class="eggIndex">
        <div class="title  bg-weight">
            <div class="titleBar">
                <router-link :to="{name: 'myEggbuy'}">
                    <span class="left">恐龙蛋</span>
                </router-link>
                <router-link  :to="{name: 'myRecharge'}">
                    <span class="right">充值中心</span>
                </router-link>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            user() {
                return this.$store.state.user.info;
            },
        },
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    .eggIndex{
        .title{
            height: 86px;
            border-bottom: 2px solid #EBEFF0;
            padding: 26px 44px;
            .titleBar{
                float: left;
                a{
                    padding: 10px 5px;
                    cursor: pointer;
                    span{
                        font-size: 14px;
                        color: #6C6F70;
                    }
                    &:last-child{
                        margin-left: 24px;
                    }
                    &:hover{
                        span{
                            color: #308697;
                        }
                    }
                    &.router-link-active{
                        border-bottom: 2px solid #308697;
                        span{
                            color: #308697;
                        }
                    }
                }

            }
        }
    }
</style>